module.exports = __webpack_public_path__ + "static/media/jade.582b35d8.png";